import { Avatar, Tooltip } from '@mui/material';
import createAvatar from '../utils/createAvatar';

interface Props {
    entity?: {
        photoUrl: string;
        name: string;
        nickName?: string;
    };
    size?: any;
    sx?: any;
}
export default function Logo({ entity, size, sx }: Props) {
    if (!entity) {
        return null;
    }
    return (
        <Tooltip title={entity.name}>
            <Avatar
                src={entity?.photoUrl}
                alt={entity?.nickName || entity.name}
                color={entity?.photoUrl ? 'default' : createAvatar(entity?.name || '').color}
                sx={{ width: size, height: size, bgcolor: 'background.paper', ...sx }}
            >
                {createAvatar(entity?.name || '').name}
            </Avatar>
        </Tooltip>
    );
}
